import React, { useEffect, useState } from 'react'
import { useLocation, } from 'react-router-dom';

import {
    settings, styles, sendMessageCloseCurrentWindowAsyncNew, getError, isUndNullEmpNew, getLanguageObj
} from '../../helpers/UtilsHelper';

import Menu from '../main/Menu';
import { ResponseClass } from '../../classes/main/responseClass';
import { GlobalFormats } from '../../classes/main/globalFormatClass';

const { app, labels, } = settings;
const { urls } = app?.backend;

const currentMethod = 'UserCode - function';

export default function UserCode({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const auth = {};
    const [userCode, setUserCode] = useState('');
    const localLocation = useLocation();
    const localQueryParameters = new URLSearchParams(localLocation.search);
    //#endregion variables

    //#region methods
    //#endregion methods

    //#region methods (others)
    const getData = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'getData';
        let response = new ResponseClass()?.getClass();
        try {
            const code_ = localQueryParameters.get('code')
            setUserCode(code_);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            await sendMessageCloseCurrentWindowAsyncNew({
                msgType: response?.msgType,
                msgText: response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
            });
        }
    }

    useEffect(() => {
        getData({
            subMethod: 'form - onLoad',
        });
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    //#endregion methods (others)

    return (
        <div>
            <Menu viewName={'home'} process={'home'} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.userCode?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active'>{labels?.userCode?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}


                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='card card-primary card-outline shadow' >

                            <div className='card-header'>
                                <h6 className='card-title'>
                                    <img alt={labels?.account?.[languageObj?.id]}
                                        style={styles.cardHeaderLogo}
                                        src={settings?.images?.icons?.info}>
                                    </img> - {labels?.userCode?.[languageObj?.id]}
                                </h6>
                                <div className='card-tools'>
                                    <button type='button'
                                        className='btn btn-tool'
                                        data-card-widget='collapse'>
                                        <i className={settings?.icons?.fasFa?.minus} /></button>
                                </div>
                            </div>

                            <div className='card-body'>
                                <div className='row'>

                                    <div className='col-md-6'>
                                        <div className='form-group'>

                                            <div className='input-group mb-3'>
                                                <div className='input-group-prepend'>
                                                    <label className='input-group-text'>
                                                        <i className={settings?.icons?.fasFa?.addressCard}></i>
                                                    </label>
                                                </div>
                                                <input type='tex'
                                                    className='form-control bg-transparent text-dark'
                                                    onClick={(e) => e.target.select()}
                                                    placeholder={labels?.userCode?.[languageObj?.id]}
                                                    value={!isUndNullEmpNew({ data: userCode, subMethod: 'inputUserCodr', })?.result ? userCode : ''}
                                                    title={labels?.userCode?.[languageObj?.id]}
                                                    readOnly />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>{/* /.container-fluid */}

                </section>
                {/* /.content */}
            </div>
        </div>
    )
}